'use strict';
import React from 'react';
import classNames from 'classnames';

/**
 * Selected Item component.
 *
 * Usage:
 *
 * ```Javascript
 * <InputField name="name" iconButton selectedItem={2}></InputField>
 * <SelectedItemList>
 * 	 <SelectedItem>Added Item</SelectedItem>
 * 	 <SelectedItem>Added Item2</SelectedItem>
 * </SelectedItemList>
 * ```
 *
 * @extends {React.Component}
 * @property {String} buttonClass Sets the button icon to be used. Defaults to 'close'.
 * @property {Boolean} disabled Renders the selected item as disabled.
 */
class SelectedItem extends React.Component {
  createDismissButton (buttonClass, disabled) {
    const classes = classNames({
      'SelectedItems-dismissButton': true,
      'Icon': true,
      [`Icon--${buttonClass}`]: buttonClass
    });

    return (
      <button className={classes} disabled={disabled}></button>
    );
  }

  /**
   * @return {JSX} JSX component markup.
   */
  render () {
    const {buttonClass, children, disabled, ...otherProps} = this.props;
    const classes = classNames({
      'SelectedItems-item': true,
      'is-disabled': disabled
    });

    return (
      <li {...otherProps} className={classes}>
        {children}
        {this.createDismissButton(buttonClass, disabled)}
      </li>
    );
  }
}

SelectedItem.defaultProps = {
  buttonClass: 'close'
};

SelectedItem.propTypes = {
};

export default SelectedItem;



// WEBPACK FOOTER //
// ./src/components/clarity-ui/inputs/selectedItems/selectedItem.jsx